import React from "react";
import { Loader2 } from "lucide-react";
import JsonModal from "./JsonModal";

export default function LogsTable({ logs, loading }) {
  const [openJson, setOpenJson] = React.useState(false);
  const [jsonData, setJsonData] = React.useState(null);
  const [openRawHex, setOpenRawHex] = React.useState(false); // State to toggle rawHex visibility
  const [expandedRawHex, setExpandedRawHex] = React.useState(null); // State to store the expanded rawHex

  const formatTime = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    d.setHours(d.getHours() + 7); // Adjust for timezone
    return d.toLocaleTimeString("vi-VN", { hour12: false });
  };

  const toggleRawHex = (rawHex) => {
    setExpandedRawHex(expandedRawHex === rawHex ? null : rawHex);
  };

  const truncateRawHex = (rawHex) => {
    return rawHex.length > 50 ? rawHex.substring(0, 50) + "..." : rawHex;
  };

  return (
    <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm">
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-primary text-xs uppercase text-white">
            <tr>
              <th className="px-3 py-2">Received At</th>
              <th className="px-3 py-2">Protocol</th>
              <th className="px-3 py-2">Msg id</th>
              <th className="px-3 py-2">IMEI</th>
              <th className="px-3 py-2">Client Ip</th>
              <th className="px-3 py-2">Client Port</th>
              <th className="px-3 py-2">Raw Hex</th>
              <th className="px-3 py-2"></th>
            </tr>
          </thead>

          <tbody>
            {!loading && logs.length === 0 && (
              <tr>
                <td
                  colSpan={8}
                  className="text-center py-4 text-gray-500 bg-gray-50"
                >
                  Không có dữ liệu.
                </td>
              </tr>
            )}

            {loading && (
              <tr>
                <td
                  colSpan={8}
                  className="py-6 text-center text-gray-500 bg-gray-50"
                >
                  <Loader2 size={20} className="animate-spin mx-auto" />
                </td>
              </tr>
            )}

            {!loading &&
              logs.map((log, idx) => (
                <tr
                  key={`${log.imei}-${log.received_at}-${idx}`}
                  className="text-center border-t border-gray-100 hover:bg-primary/5"
                >
                  <td className="px-3 py-2">{formatTime(log?.received_at)}</td>
                  <td className="px-3 py-2">{log?.protocol ?? "-"}</td>
                  <td className="px-3 py-2">{log?.msg_id ?? "-"}</td>
                  <td className="px-3 py-2 font-mono text-xs">
                    {log?.imei}
                  </td>
                  <td className="px-3 py-2">{log?.client_ip ?? "_"}</td>
                  <td className="px-3 py-2">{log?.client_port ?? "-"}</td>
                  <td className="px-3 py-2">
                    <div className="flex items-center gap-2">
                      <span>{truncateRawHex(log.raw_hex)}</span>
                      {log.raw_hex.length > 50 && (
                        <button
                          onClick={() => toggleRawHex(log.raw_hex)}
                          className="text-blue-500 text-xs"
                        >
                          {expandedRawHex === log.raw_hex
                            ? "Thu gọn"
                            : "Xem thêm"}
                        </button>
                      )}
                    </div>
                    {expandedRawHex === log.raw_hex && (
                      <div className="mt-2 text-sm text-gray-600">
                        <pre>{log.raw_hex}</pre>
                      </div>
                    )}
                  </td>
                  <td className="px-3 py-2">
                    <button
                      className="px-3 py-1 bg-primary text-white rounded text-xs"
                      onClick={() => {
                        setJsonData(log);
                        setOpenJson(true);
                      }}
                    >
                      JSON
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <JsonModal
        open={openJson}
        onClose={() => setOpenJson(false)}
        data={jsonData}
      />
    </div>
  );
}
